import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class CircularProgress extends Vue {
	@Prop({ type: Number, default: 80 }) width
	@Prop({ type: Number, default: 80 }) height
	@Prop({ type: Number, default: 4 }) strokeWidth
	@Prop({ type: Number, default: 0 }) progress
	@Prop({ type: String, default: 'WhiteSmoke' }) trackBackgroundColor
	@Prop({ type: String, default: 'DodgerBlue' }) barColor

	slotStyle = {
		height: this.height + 'px',
		width: this.width + 'px',
	}

	get cx() {
		return this.width / 2
	}

	get cy() {
		return this.height / 2
	}

	get r() {
		return (this.width - this.strokeWidth) / 2
	}

	get viewBox() {
		return '0 0 ' + this.width + ' ' + this.height
	}

	get value() {
		return (100 - this.progress).toString()
	}
}
